<template>
  <div class="components__competencies-overview">
    <div class="competency" v-for="competency in competencies" v-bind:key="competency.id">
      <CompetencyAccordion v-bind:competency="competency"></CompetencyAccordion>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from "vue";
  import CompetencyAccordion from "vue/applications/frontend/components/competency-accordion.vue"
  import { useStore } from "vuex";

  const store = useStore();
  
  const competencies = computed(() => store.state.gon.competencies)
</script>
